import React from 'react';
import styled from 'styled-components';

const TasksDiv = styled.div`
  // todo color
  ${(props) => `background-color: #880808;`}
  ${(props) => `color: ${props.theme.palette.common.white};`}
  width: 20px;
  height: 20px;
  cursor: pointer;
  padding: 1px;
  border-radius: 10px;
  display: flex;
  flex-direction: row;
  align-items: center;
  align-content: center;
  justify-content: center;
  font-family: 'Muli', sans-serif;
  font-size: 1rem;
  font-weight: 600;
  line-height: 1;
`;

type TasksIconProps = {
  numTasks?: number;
  onTasksClick: () => void;
};

export const TasksIcon = ({ numTasks, onTasksClick }: TasksIconProps) => (
  <TasksDiv onClick={onTasksClick}>{numTasks}</TasksDiv>
);
